var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import PowerEfficiencyFlag from './PowerEfficiencyFlag';
export var EfficiencyFlagWrapper = styled.ol(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  /* The margin is set here, because with no margin, in some cases 4 EEK flags would fit into one column (where the max should be 3). \n  * The margin prevents this from happening. */\n  margin: 0 12px;\n  padding: 0;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  /* The margin is set here, because with no margin, in some cases 4 EEK flags would fit into one column (where the max should be 3). \n  * The margin prevents this from happening. */\n  margin: 0 12px;\n  padding: 0;\n  justify-content: center;\n"])));
var PowerEfficiencySlot = function (_a) {
    var powerEfficiency = _a.powerEfficiency, powerEfficiencyList = _a.powerEfficiencyList, name = _a.name;
    /**
     * This function checks, if a list of EEK Flags in given or just one EEK flag and then returns a list or single PowerEfficiencyFlag.
     *
     * Background for this solution: GraphQL delivers the EEK Flags in a single Object (old - only 1 Flag) and now as list (multiple flags).
     * If - for some reason - GraphQL does not provide the list of EEK flags, the fallback option would be to show at least one EEK Flag,
     * which stands in powerEfficiency.
     */
    var Slot = function () {
        if (powerEfficiencyList && powerEfficiencyList.length > 0) {
            return (React.createElement(EfficiencyFlagWrapper, null, powerEfficiencyList.map(function (flagProps, idx) { return (React.createElement(PowerEfficiencyFlag
            // eslint-disable-next-line react/no-array-index-key
            , __assign({ 
                // eslint-disable-next-line react/no-array-index-key
                key: "flag-" + idx + "-efficiency-" + flagProps.text }, flagProps, { name: name }))); })));
        }
        if (powerEfficiency) {
            return (React.createElement(EfficiencyFlagWrapper, null,
                React.createElement(PowerEfficiencyFlag, __assign({}, powerEfficiency, { name: name }))));
        }
        return React.createElement(React.Fragment, null);
    };
    return Slot();
};
export default PowerEfficiencySlot;
var templateObject_1;
//# sourceMappingURL=index.js.map